<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Therapy Sessions' : 'Deleted Therapy Sessions'"
              ></h3>
              <section v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/therapy_sessions/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </section>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    hide-details="auto"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="patient"
                    v-model="filter.patient_id"
                    :items="patients"
                    label="Patient"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-account-circle"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="device"
                    v-model="filter.device_id"
                    :items="devices"
                    label="Device"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-medical-bag"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statuses"
                    label="Status"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="3">
                  <v-autocomplete
                    solo
                    rounded
                    ref="active"
                    v-model="filter.is_active"
                    :items="activeStatuses"
                    label="Active Status"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-check-circle"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.start_date"
                        solo
                        rounded
                        label="Start Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.start_date = null; (page = 1), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="startDateMenu = false; (page = 1), getData()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col sm="3">
                  <v-menu
                    ref="endDateMenu"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.end_date"
                        solo
                        rounded
                        label="End Date"
                        hide-details="auto"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.end_date = null; (page = 1), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="endDateMenu = false; (page = 1), getData()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col sm="3">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.min_duration"
                    label="Min Duration (min)"
                    type="number"
                    hide-details="auto"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-timer"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="therapySessions.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" :style="`height: ${tableHeight}px`">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="tableHeight"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Patient</th>
                      <th class="text-left">Device</th>
                      <th class="text-left">Procedure</th>
                      <th class="text-left">Start Time</th>
                      <th class="text-left">End Time</th>
                      <th class="text-left">Duration</th>
                      <th class="text-left">Distance (m)</th>
                      <th class="text-left">Session Status</th>
                      <th class="text-left">Intensity</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="therapySessions.length != 0">
                    <tr v-for="(session, i) in therapySessions" :key="`session${i}`">
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="session.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Session is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="session.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Session is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ session.patient ? `${session.patient.first_name} ${session.patient.last_name}` : "N/A" }}
                      </td>
                      <td>
                        {{ session.device ? `${session.device.model_name}` : "N/A" }}
                      </td>
                      <td>
                        {{ session.procedure ? session.procedure.name : "N/A" }}
                      </td>
                      <td>{{ session.start_time || "N/A" }}</td>
                      <td>{{ session.end_time || "N/A" }}</td>
                      <td>{{ session.duration || "N/A" }}</td>
                      <td>{{ session.distance_covered || "N/A" }}</td>
                      <td>
                        <v-chip
                          small
                          :color="getStatusColor(session.status)"
                          text-color="white"
                        >
                          {{ getStatusText(session.status) }}
                        </v-chip>
                      </td>
                      <td>{{ getIntensityLevel(session) }}</td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <div class="d-flex align-center">
                            <!-- Delete Button -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  fab
                                  x-small
                                  color="error"
                                  @click="Delete_this(session.id)"
                                  class="mr-1"
                                >
                                  <v-icon dark> mdi-delete </v-icon>
                                </v-btn>
                              </template>
                              <span>Delete this session</span>
                            </v-tooltip>
                            
                            <!-- Edit Button -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  fab
                                  x-small
                                  color="primary"
                                  :to="`/therapy_sessions/${encryptIt(session.id)}`"
                                  class="mr-1"
                                >
                                  <v-icon dark> mdi-pencil </v-icon>
                                </v-btn>
                              </template>
                              <span>Edit this session</span>
                            </v-tooltip>
                            
                            <!-- Session Log Button -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  fab
                                  x-small
                                  color="success"
                                  :to="`/therapy-sessions/${encryptIt(session.id)}/session-logs`"
                                  class="mr-1"
                                >
                                  <v-icon dark> mdi-file-document-multiple </v-icon>
                                </v-btn>
                              </template>
                              <span>View session logs</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(session.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this session</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_session" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Therapy session deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_session = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_session" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Therapy session restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_session = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "therapySessionsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        patient_id: "",
        device_id: "",
        procedure_id: "",
        status: "",
        is_active: "",
        start_date: "",
        end_date: "",
        min_duration: "",
        max_duration: "",
        min_distance: "",
        max_distance: "",
        show_deleted: false,
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_session: false,
      restore_session: false,
      is_restored_session: false,
      therapySessions: [],
      statuses: [
        {
          id: 0,
          text: "Select Status",
          value: "",
        },
        { id: "COMPLETED", text: "Completed", value: "1" },
        { id: "STOPPED", text: "Stopped", value: "2" },
        { id: "EMERGENCY_STOPPED", text: "Emergency Stopped", value: "3" },
      ],
      activeStatuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      patients: [
        {
          id: 0,
          text: "Select Patient",
          value: "",
        },
      ],
      devices: [
        {
          id: 0,
          text: "Select Device",
          value: "",
        },
      ],
      procedures: [
        {
          id: 0,
          text: "Select Procedure",
          value: "",
        },
      ],
      isLoading: false,
      isExcelloading: false,
      startDateMenu: false,
      endDateMenu: false,
      ExportTherapySessions: [],
      Export_therapy_sessions: [],
      excel_fields: {
        "Sr No": "sr_no",
        Patient: "patient_name",
        Device: "device_name",
        Procedure: "procedure_name",
        Duration: "duration",
        Status: "status",
        "Is Active": "is_active",
      },
    };
  },
  computed: {
    tableHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 250; // Mobile phones
        case 'sm': return 300; // Tablets
        case 'md': return 400; // Small laptops
        case 'lg': return 500; // Desktop
        case 'xl': return 600; // Large desktop
        default: return 400;
      }
    }
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=therapy_session`)
        .then((masters) => {
          masters = masters.data;
          // Patients
          if (masters.patients) {
            masters.patients.forEach((patient) => {
              this.patients.push({
                id: patient.id,
                text: `${patient.first_name} ${patient.last_name}`,
                value: patient.id,
              });
            });
          }
          // Devices
          if (masters.devices) {
            masters.devices.forEach((device) => {
              this.devices.push({
                id: device.id,
                text: `${device.model_name} (${device.serial_number})`,
                value: device.id,
              });
            });
          }
          // Procedures
          if (masters.procedures) {
            masters.procedures.forEach((procedure) => {
              this.procedures.push({
                id: procedure.id,
                text: procedure.name,
                value: procedure.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          // Only redirect to login if it's actually an authentication error
          if (error.response && error.response.status === 401) {
            //window.location.href = "/auth/login";
          }
        });
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.patient_id = this.filter.patient_id
        ? this.filter.patient_id
        : "";
      this.filter.device_id = this.filter.device_id
        ? this.filter.device_id
        : "";
      this.filter.procedure_id = this.filter.procedure_id
        ? this.filter.procedure_id
        : "";
      this.filter.status = this.filter.status
        ? this.filter.status
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date
        ? this.filter.end_date
        : "";
      this.filter.min_duration = this.filter.min_duration
        ? this.filter.min_duration
        : "";
      this.filter.max_duration = this.filter.max_duration
        ? this.filter.max_duration
        : "";
      this.filter.min_distance = this.filter.min_distance
        ? this.filter.min_distance
        : "";
      this.filter.max_distance = this.filter.max_distance
        ? this.filter.max_distance
        : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&patient_id=" +
        this.filter.patient_id +
        "&device_id=" +
        this.filter.device_id +
        "&procedure_id=" +
        this.filter.procedure_id +
        "&status=" +
        this.filter.status +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&min_duration=" +
        this.filter.min_duration +
        "&max_duration=" +
        this.filter.max_duration +
        "&min_distance=" +
        this.filter.min_distance +
        "&max_distance=" +
        this.filter.max_distance +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`therapy_sessions?${query}`)
        .then((response) => {
          this.therapySessions = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // //window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_session = true;
      await axios
        .post(`/therapy_sessions/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_session = false;
          this.is_deleted_session = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          //window.location.href = "/auth/login";
        });
    },
    async generateExcel() {
      this.isExcelloading = true;
      
      // Build query string with current filters
      let query =
        "show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&patient_id=" +
        this.filter.patient_id +
        "&device_id=" +
        this.filter.device_id +
        "&procedure_id=" +
        this.filter.procedure_id +
        "&status=" +
        this.filter.status +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&min_duration=" +
        this.filter.min_duration +
        "&max_duration=" +
        this.filter.max_duration +
        "&min_distance=" +
        this.filter.min_distance +
        "&max_distance=" +
        this.filter.max_distance +
        "&search_keyword=" +
        this.filter.search_keyword;

      try {
        const response = await axios.get(`therapy_sessions/excel?${query}`, {
          responseType: 'blob',
        });
        
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'therapy_sessions.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
          //window.location.href = "/auth/login";
        }
      }
      
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_session = true;
      await axios
        .post(`/therapy_sessions/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_session = false;
          this.is_restored_session = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          //window.location.href = "/auth/login";
        });
    },
    getStatusText(status) {
      switch(status) {
        case 1:
          return 'Completed';
        case 2:
          return 'Stopped';
        case 3:
          return 'Emergency Stopped';
        default:
          return 'Unknown';
      }
    },
    getStatusColor(status) {
      switch(status) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'error';
        default:
          return 'secondary';
      }
    },
    getIntensityLevel(session) {
      const distance = session.distance_covered || 0;
      const duration = parseFloat(session.duration) || 0;
      const unweighting = session.unweighting_percentage || 50;

      // Calculate intensity based on speed and load
      const speed = duration > 0 ? distance / duration : 0;
      const load = 100 - unweighting; // Higher unweighting = lower load

      if (speed <= 10 && load <= 30) {
        return 'Low';
      } else if (speed <= 20 && load <= 60) {
        return 'Moderate';
      } else if (speed <= 30 && load <= 80) {
        return 'High';
      } else {
        return 'Very High';
      }
    },
    viewSessionLogs(session) {
      // Navigate to session logs page with therapy session filter
      this.$router.push({
        path: '/session_logs',
        query: {
          therapy_session_id: session.id,
          // patient_name: `${session.patient_first_name} ${session.patient_last_name}`,
          // filter: 'therapy_session'
        }
      });
    },
    viewControlLogs(session) {
      // Navigate to control logs page with therapy session filter
      this.$router.push({
        path: '/control_logs',
        query: {
          therapy_session_id: session.id,
        }
      });
    },
  },
};
</script>